import { render, staticRenderFns } from "./iconConfiguration.vue?vue&type=template&id=12475150&scoped=true"
import script from "./iconConfiguration.vue?vue&type=script&lang=js"
export * from "./iconConfiguration.vue?vue&type=script&lang=js"
import style0 from "./iconConfiguration.vue?vue&type=style&index=0&id=12475150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12475150",
  null
  
)

export default component.exports